
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Fotter, Header } from "../components/layout";
import { aboutUsImage } from '../assets';
import { motion } from 'framer-motion';
import {
  FaClock,
  FaUsers,
  FaAward,
  FaHeart,
  FaFire,
  FaLeaf,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaQuoteLeft,
  FaCheckCircle,
  FaFish,
  FaStar,
  FaUtensils
} from 'react-icons/fa';

import {
  PiChefHatLight,
  PiCowFill
} from "react-icons/pi";

import {
  MdDeliveryDining
} from 'react-icons/md';

import {
  GiHotSpices,
  GiChickenOven,
  GiMeal
} from 'react-icons/gi';

function AboutUs() {
  const { t } = useTranslation();

  // Hero Section Data
  const heroData = {
    icon: GiMeal,
    title: "hayacomAboutTitle",
    description:
      "hayacomAboutDescription",
    iconColor: "text-color-1",
    bgGradient:
      "from-color-2 via-color-4 to-color-2 dark:from-back-darkprimery dark:to-back-darksecondary"
  };

  // Stats Section Data
  const statsData = [
    {
      icon: FaClock,
      value: "15+",
      label: "hayacomStatsYears",
      color: "text-color-1"
    },
    {
      icon: FaUsers,
      value: "100K+",
      label: "hayacomStatsCustomers",
      color: "text-color-1"
    },
    {
      icon: FaAward,
      value: "100%",
      label: "hayacomStatsQuality",
      color: "text-color-1"
    },
    {
      icon: PiChefHatLight,
      value: "25+",
      label: "hayacomStatsChefs",
      color: "text-color-1"
    }
  ];

  // Story Section Data
  const storyData = {
    title: "hayacomStoryTitle",
    paragraphs: [
      "hayacomStoryParagraph1",
      "hayacomStoryParagraph2",
      "hayacomStoryParagraph3"
    ],
    features: [
      {
        text: "hayacomFeature1",
        icon: FaCheckCircle
      },
      {
        text: "hayacomFeature2",
        icon: FaCheckCircle
      }
    ],
    image: aboutUsImage,
    quoteIcon: FaQuoteLeft
  };

  // Values Section Data
  const valuesData = {
    title: "hayacomValuesTitle",
    description: "hayacomValuesDescription",
    items: [
      {
        icon: FaHeart,
        title: "hayacomValue1Title",
        description: "hayacomValue1Description",
        bgColor: "bg-red-50 dark:bg-red-900/20",
        iconColor: "text-red-500"
      },
      {
        icon: FaFire,
        title: "hayacomValue2Title",
        description: "hayacomValue2Description",
        bgColor: "bg-orange-50 dark:bg-orange-900/20",
        iconColor: "text-orange-500"
      },
      {
        icon: FaLeaf,
        title: "hayacomValue3Title",
        description: "hayacomValue3Description",
        bgColor: "bg-green-50 dark:bg-green-900/20",
        iconColor: "text-green-500"
      },
      {
        icon: GiHotSpices,
        title: "hayacomValue4Title",
        description: "hayacomValue4Description",
        bgColor: "bg-amber-50 dark:bg-amber-900/20",
        iconColor: "text-amber-600"
      }
    ]
  };

  // Specialties Section Data
  const specialtiesData = {
    title: "hayacomSpecialtiesTitle",
    description: "hayacomSpecialtiesDescription",
    items: [
      {
        icon: PiCowFill,
        name: "hayacomSpecialty1Title",
        description: "hayacomSpecialty1Description"
      },
      {
        icon: FaFire,
        name: "hayacomSpecialty2Title",
        description: "hayacomSpecialty2Description"
      },
      {
        icon: GiChickenOven,
        name: "hayacomSpecialty3Title",
        description: "hayacomSpecialty3Description"
      },
      {
        icon: FaFish,
        name: "hayacomSpecialty4Title",
        description: "hayacomSpecialty4Description"
      }
    ]
  };

  // Contact Section Data
  const contactData = {
    title: "Visit Us",
    items: [
      {
        icon: FaMapMarkerAlt,
        title: "address",
        value:  "4 Ibn Katheer Street, at the corner of El Nile Street, next to the Saudi Embassy."
      },
      {
        icon: FaPhoneAlt,
        title: "phone",
        value: "+201033124243"
      },
      {
        icon: FaClock,
        title: "workingHours",
        value: "Daily from 10:00 AM to 1:00 AM."
      }
     
    ],
    mapPlaceholder: "hayacomMapPlaceholder"
  };

  return (
    <>
      <Header active={2} DropActive={2} />

      <div className="bg-back-primery dark:bg-back-darkprimery overflow-hidden">

        {/* Hero Section */}
        <div className={`relative bg-gradient-to-br ${heroData.bgGradient} py-24 md:py-32 overflow-hidden`}>

          <div className="absolute inset-0 bg-black/55 z-0"></div>

          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-10 left-10 w-72 h-72 bg-color-1 rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-72 h-72 bg-color-3 rounded-full blur-3xl"></div>
          </div>

          <div className="container relative z-10 text-center">

            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >

              <div className="flex justify-center mb-6">
                <div className="w-28 h-28 rounded-full bg-white/10 backdrop-blur-xl border border-white/20 flex items-center justify-center shadow-2xl">
                  <heroData.icon className={`text-6xl ${heroData.iconColor}`} />
                </div>
              </div>

              <h1 className="h1 text-white mb-6">
                {t(heroData.title)}
              </h1>

              <div className="w-32 h-1 bg-color-1 mx-auto rounded-full mb-8"></div>

              <p className="body-1 text-white/90 max-w-4xl mx-auto leading-loose">
                {t(heroData.description)}
              </p>

            </motion.div>
          </div>
        </div>

        {/* Story Section */}
        <div className="container py-20 md:py-32">

          <div className="grid md:grid-cols-2 gap-16 items-center">

            <motion.div
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >

              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-color-1/10 mb-6">
                <FaStar className="text-color-1" />
                <span className="body-3 text-color-1">
                  {t("hayacomStoryBadge")}
                </span>
              </div>

              <h2 className="h2 text-tcolor-4 dark:text-tcolor-1 mb-5">
                {t(storyData.title)}
              </h2>

              <div className="w-24 h-1 bg-color-1 rounded-full mb-8"></div>

              {storyData.paragraphs.map((para, idx) => (
                <p
                  key={idx}
                  className="text-n-6 dark:text-tcolor-2 body-2 mb-5 leading-loose"
                >
                  {t(para)}
                </p>
              ))}

              <div className="mt-10 flex flex-wrap gap-5">

                {storyData.features.map((feature, idx) => (
                  <div
                    key={idx}
                    className="flex items-center gap-3 bg-white dark:bg-back-darksecondary px-5 py-3 rounded-xl shadow-lg border border-color-1/10"
                  >
                    <feature.icon className="text-color-1 text-xl" />

                    <span className="body-3 text-tcolor-4 dark:text-tcolor-1">
                      {t(feature.text)}
                    </span>
                  </div>
                ))}

              </div>

            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="relative"
            >

              <div className="absolute -top-6 -right-6 w-full h-full border-2 border-color-1 rounded-[2rem]"></div>

              <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border border-white/10">
                <img
                  src={storyData.image}
                  alt="Hayacom Restaurant"
                  className="w-full h-[500px] object-cover hover:scale-105 duration-700"
                />
              </div>

              <div className="absolute -bottom-8 -left-8 bg-color-1 text-white p-6 rounded-2xl shadow-2xl">
                <storyData.quoteIcon className="text-4xl" />
              </div>

            </motion.div>

          </div>
        </div>

        {/* Stats Section */}
        <div className="relative py-20 bg-gradient-to-r from-color-2 via-color-4 to-color-2 overflow-hidden">

          <div className="absolute inset-0 bg-black/40"></div>

          <div className="container relative z-10">

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

              {statsData.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="text-center bg-white/5 backdrop-blur-lg border border-white/10 rounded-3xl p-8 hover:-translate-y-2 duration-300"
                >

                  <stat.icon className={`text-5xl ${stat.color} mx-auto mb-4`} />

                  <div className="text-4xl font-kufi text-white mb-2">
                    {stat.value}
                  </div>

                  <div className="text-white/75 body-3">
                    {t(stat.label)}
                  </div>

                </motion.div>
              ))}

            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="container py-20 md:py-32">

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >

            <h2 className="h2 text-tcolor-4 dark:text-tcolor-1 mb-5">
              {t(valuesData.title)}
            </h2>

            <div className="w-24 h-1 bg-color-1 mx-auto rounded-full mb-6"></div>

            <p className="body-2 text-n-6 dark:text-tcolor-2 max-w-3xl mx-auto leading-loose">
              {t(valuesData.description)}
            </p>

          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">

            {valuesData.items.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className={`${value.bgColor} rounded-[2rem] p-8 text-center shadow-xl border border-white/20 hover:-translate-y-2 duration-300`}
              >

                <div className={`w-20 h-20 ${value.bgColor} rounded-full flex items-center justify-center mx-auto mb-6 shadow-md`}>
                  <value.icon className={`text-4xl ${value.iconColor}`} />
                </div>

                <h3 className="h6 text-tcolor-4 dark:text-tcolor-1 mb-4">
                  {t(value.title)}
                </h3>

                <p className="body-3 text-gray-600 dark:text-gray-300 leading-loose">
                  {t(value.description)}
                </p>

              </motion.div>
            ))}

          </div>
        </div>

        {/* Specialties Section */}
        <div className="bg-back-secondary dark:bg-back-darksecondary py-20 md:py-32">

          <div className="container">

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >

              <h2 className="h2 text-tcolor-4 dark:text-tcolor-1 mb-5">
                {t(specialtiesData.title)}
              </h2>

              <div className="w-24 h-1 bg-color-1 mx-auto rounded-full mb-6"></div>

              <p className="body-2 text-n-6 dark:text-tcolor-2 max-w-3xl mx-auto leading-loose">
                {t(specialtiesData.description)}
              </p>

            </motion.div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">

              {specialtiesData.items.map((specialty, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="group bg-white dark:bg-back-darkprimery rounded-[2rem] p-8 text-center shadow-xl border border-color-1/10 hover:-translate-y-3 duration-500"
                >

                  <div className="w-24 h-24 bg-gradient-to-br from-color-1/20 to-color-3/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 duration-300">
                    <specialty.icon className="text-5xl text-color-1" />
                  </div>

                  <h3 className="h6 text-tcolor-4 dark:text-tcolor-1 mb-4">
                    {t(specialty.name)}
                  </h3>

                  <p className="body-3 text-gray-600 dark:text-gray-300 leading-loose">
                    {t(specialty.description)}
                  </p>

                </motion.div>
              ))}

            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="container py-20 md:py-32">

          <div className="grid md:grid-cols-2 gap-14">

            <motion.div
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >

              <h2 className="h2 text-tcolor-4 dark:text-tcolor-1 mb-5">
                {t(contactData.title)}
              </h2>

              <div className="w-24 h-1 bg-color-1 rounded-full mb-8"></div>

              <div className="space-y-6">

                {contactData.items.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-4 bg-white dark:bg-back-darksecondary p-5 rounded-2xl shadow-lg border border-color-1/10"
                  >

                    <div className="w-14 h-14 rounded-xl bg-color-1/10 flex items-center justify-center flex-shrink-0">
                      <item.icon className="text-color-1 text-2xl" />
                    </div>

                    <div>
                      <h3 className="h6 text-tcolor-4 dark:text-tcolor-1 mb-1">
                        {t(item.title)}
                      </h3>

                      <p className="body-3 text-gray-600 dark:text-gray-300 leading-loose">
                        {t(item.value)}
                      </p>
                    </div>

                  </div>
                ))}

              </div>

            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="bg-white dark:bg-back-darksecondary rounded-[2rem] p-6 shadow-2xl border border-color-1/10"
            >


<div
  className="
    relative
    h-full
    min-h-[400px]
    overflow-hidden
    rounded-[1.5rem]
    border
    border-color-1/20
    bg-back-secondary
    dark:bg-back-darktertiary
  "
>
  <iframe
    src="https://www.google.com/maps?q=30.030345916748047,31.21833038330078&z=17&hl=ar&output=embed"
    title={t("hayacomMapTitle")}
    className="
      absolute
      inset-0
      w-full
      h-full
      border-0
    "
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
  />

  {/* Location Badge */}
  <div
    className="
      absolute
      top-4
      start-4
      z-10
      flex
      items-center
      gap-2
      max-w-[calc(100%-2rem)]
      rounded-2xl
      border
      border-white/20
      bg-white/85
      dark:bg-back-darksecondary/90
      px-4
      py-3
      backdrop-blur-xl
      shadow-xl
      pointer-events-none
    "
  >
    <div
      className="
        flex
        w-10
        h-10
        shrink-0
        items-center
        justify-center
        rounded-xl
        bg-color-1
        text-white
      "
    >
      <FaMapMarkerAlt className="text-lg" />
    </div>

    <div className="min-w-0">
      <h3 className="font-kufi text-sm text-tcolor-4 dark:text-white">
        {t("hayacomMapLocation")}
      </h3>

      <p className="truncate font-kufi text-xs text-gray-500 dark:text-gray-300">
        {t("hayacomMapAddress")}
      </p>
    </div>
  </div>
</div>



            </motion.div>

          </div>
        </div>

      </div>

      <Fotter />
    </>
  );
}

export default AboutUs;